<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button @click="save('userForm')" :disabled="formsData.userForm.disabled">
        <span>Save</span>
      </ion-button>
    </ion-buttons>
    <ion-title>Billing details</ion-title>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <el-form :model="formsData.userForm" :rules="formsData.userForm.rules" :ref="el => formsData.userForm.ref = el"
             :label-position="'top'" @submit.prevent="goNext('userForm')" @keyup.enter="goNext('userForm')">
      <div class="form_part">
        <el-form-item label="Australian Business Number" prop="abn" :required='true'>
          <input type="tel" class="el-input__inner" :ref='el => formsData.userForm.abn.ref = el'
                 :value="formsData.userForm.abn.value" :placeholder="'00 000 000 000'"
                 v-imask="formsData.userForm.abn.mask" @accept="onFormMaskAccept($event, 'userForm', 'abn')"
                 @blur="checkFormValidation('userForm', true, 'abn')">
        </el-form-item>
        <el-form-item label="Business Name" :prop="'businessName'" :required='true'>
          <el-input v-model="formsData.userForm.businessName.value" autocomplete="off" placeholder="Business Name"
                    :maxlength="40" @keyup="formsData.userForm.businessName.value = $event.target.value"
                    :disabled="formsData.userForm.businessName.disabled"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="formsData.userForm.businessName.disabled" @change="onNameCheckboxChange">Same as
            Business Name
          </el-checkbox>
        </el-form-item>
        <el-form-item label="Billing Address" prop="billingAddress" :required='true'>
          <div class="el-input el-input--prefix"
               :class="formsData.userForm.billingAddress.disabled ? 'is-disabled' : ''">
            <vue-google-autocomplete id="map" classname="el-input__inner"
                                     :ref='el => formsData.userForm.billingAddress.ref = el'
                                     v-model="formsData.userForm.billingAddress.value.text"
                                     placeholder="Billing Address" v-on:placechanged="setAddressData"
                                     @keyup="setAddress" :country="['au', 'ua', 'usa']"
                                     :disabled="formsData.userForm.billingAddress.disabled">
            </vue-google-autocomplete>
            <span class="el-input__prefix"><i class="el-input__icon el-icon-search"></i></span>
          </div>
        </el-form-item>

        <el-form-item v-if="userData.address.lat ? true : false">
          <el-checkbox v-model="formsData.userForm.billingAddress.disabled" @change="onAddressCheckboxChange">Same as
            Pharmacy Address
          </el-checkbox>
        </el-form-item>
        <el-form-item label="Billing Email" prop="billing_email" :required="true">
          <el-input
              type="email"
              v-model="formsData.userForm.billing_email.value"
              placeholder="email@gmail.com"
              @input="checkFormValidation('userForm', false)"
              :disabled="formsData.userForm.billing_email.disabled"
          ></el-input>
        </el-form-item>
        <el-form-item >
          <el-checkbox v-model="formsData.userForm.billing_email.disabled" @change="onEmailCheckBoxChange">Same as
            Pharmacy Email
          </el-checkbox>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>


<script>
import {
  onMounted,
  inject,
} from 'vue';

import {
  addIcons
} from 'ionicons'
import {
  arrowBackOutline
} from 'ionicons/icons'

addIcons({
  'arrow-back-outline': arrowBackOutline
})
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
} from '@ionic/vue';

import {
  useStore
} from 'vuex'
import {
  useRouter,
  useRoute,
  onBeforeRouteLeave,
} from 'vue-router'
import formHooks from '@/hooks/form/form'
import formValidate from '@/hooks/form/validate/validate'
import formMasks from '@/hooks/form/mask/mask'

import IMaskDirective from '@/directives/vue-imask/directive';
import IMask from 'imask/esm/imask';

import addressText from '@/helpers/address/address.js'

import {
  VueGoogleAutocomplete
} from '@/components/components'

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,

    VueGoogleAutocomplete,
  },
  directives: {
    imask: IMaskDirective
  },
  setup() {
    const $store = useStore()
    const $router = useRouter()
    const $route = useRoute()
    const setPageClassGlobal = inject(['setPageClassGlobal']);

    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const abn = userData.abn;
    console.log(userData)
    const formsDataArray = {
      userForm: {
        abn: {
          value: abn ? IMask.createMask(formMasks.abn).resolve(abn) : '',
          mask: formMasks.abn,
          resetValue: true,
          validators: [{
            validator: (rule, formField, callback) => {
              formValidate.validate(rule, formField, 'abn', callback, setFormValidation);
            },
          }]
        },

        billingAddress: {
          value: {
            text: userData.billing.address.text || '',
          },
          valueTemp: '',
          disabled: userData.address.lat && userData.billing.address.text && addressText(userData.address) == userData.billing.address.text ? true : false,
          resetValue: true,
          validators: [{
            validator: (rule, formField, callback) => {
              formValidate.validate(rule, formField, 'address', callback, setFormValidation);
            },
          }]
        },
        billing_email: {
          value: userData.billingEmail ? userData.billingEmail : userData.email,
          valueTemp: '',
          disabled: userData.billingEmail == userData.email ? true : false,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                    rule,
                    formField,
                    "email",
                    callback,
                    setFormValidation
                );
              },
              trigger: ["blur", "enter"],
            },
          ],
        },
        businessName: {
          value: userData.billing.name || userData.name,
          valueTemp: '',
          disabled: userData.billing.name == userData.name ? true : false,
          resetValue: true,
          validators: [{
            validator: (rule, formField, callback) => {
              formValidate.validate(rule, formField, 'name', callback, setFormValidation);
            },
          }]
        },
      }
    };

    const setAddress = () => {
      formsData.userForm.billingAddress.value.text = null;
      checkFormValidation('userForm', true, 'billingAddress');
    }

    const setAddressData = (addressData, placeResultData) => {
      formsData.userForm.billingAddress.value.text = placeResultData.formatted_address;
      formsData.userForm.billingAddress.ref.update(formsData.userForm.billingAddress.valueTemp);
      checkFormValidation('userForm', true, 'billingAddress');
    };

    const onAddressCheckboxChange = () => {
      if (formsData.userForm.billingAddress.disabled) {
        formsData.userForm.billingAddress.valueTemp = formsData.userForm.billingAddress.value.text
        formsData.userForm.billingAddress.value.text = addressText(userData.address);
        formsData.userForm.billingAddress.ref.update(addressText(userData.address));
        formsData.userForm.billingAddress.disabled = true;
      } else {
        formsData.userForm.billingAddress.value.text = formsData.userForm.billingAddress.valueTemp;
        formsData.userForm.billingAddress.ref.update(formsData.userForm.billingAddress.valueTemp);
        formsData.userForm.billingAddress.disabled = false;
      }
      checkFormValidation('userForm', true, 'billingAddress');
    };

    const onNameCheckboxChange = () => {
      if (formsData.userForm.businessName.disabled) {
        formsData.userForm.businessName.valueTemp = formsData.userForm.businessName.value;
        formsData.userForm.businessName.value = userData.name
        formsData.userForm.businessName.disabled = true;
      } else {
        formsData.userForm.businessName.value = formsData.userForm.businessName.valueTemp;
        formsData.userForm.businessName.disabled = false;
      }
      checkFormValidation('userForm', true, 'businessName');
    };

    const onEmailCheckBoxChange = () => {
      if (formsData.userForm.billing_email.disabled) {
        formsData.userForm.billing_email.valueTemp = formsData.userForm.billing_email.value;
        formsData.userForm.billing_email.value = userData.email
        formsData.userForm.billing_email.disabled = true;
      } else {
        formsData.userForm.billing_email.value = formsData.userForm.billing_email.valueTemp;
        formsData.userForm.billing_email.disabled = false;
      }
      checkFormValidation('userForm', true, 'billing_email');
    }

    const goBack = () => {
      $router.push({
        name: 'profile_edit'
      })
    };

    const save = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          return (async () => {
            try {
              checkFormChanged('userForm', true);
              await $store.dispatch('SAVE_USER_DATA', getFormValues(formName));
              copyFormResetValue('userForm', true);
              goBack();
            } catch (error) {
              console.log(error);
            }
          })();
        } else {
          setFormValidation(formName, false, false);
          console.log('error submit!!');
          return false;
        }
      });
    }

    const skip = () => {
      $store.dispatch('addAuthPageBack', $route.name);
      $router.push({
        name: 'auth_address',
      })
    }

    onBeforeRouteLeave((to, from, next) => {
      (async () => {
        try {
          let leave = await checkFormChanged('userForm');
          if (leave == 'save') {
            await save('userForm');
          } else if (!leave) {
            next(false)
          } else {
            next()
          }
        } catch (error) {
          next(false);
          console.log(error);
        }
      })();
    })

    onMounted(() => {
      setPageClassGlobal('global_profile_page');
      setFormRefs();
      formsData.userForm.billingAddress.ref.update(formsData.userForm.billingAddress.value.text);
      checkFormValidation('userForm', true);
    });

    const {
      ['onFormMaskAccept']: onFormMaskAccept,
      checkFormValidation,
      setFormValidation,
      copyFormResetValue,
      checkFormChanged,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      userData,
      formsData,
      onFormMaskAccept,
      checkFormValidation,
      goBack,
      save,
      skip,
      userRole,
      setAddressData,
      setAddress,
      onAddressCheckboxChange,
      onNameCheckboxChange,
      onEmailCheckBoxChange
    }
  },
}
</script>